import React from 'react'
import SliderAbout2Sec1 from './SliderAbout2Sec1/SliderAbout2Sec1'
import SliderAbout2Sec2 from './SliderAbout2Sec2/SliderAbout2Sec2'

function SliderAbout2() {
  return (
    <>
      <SliderAbout2Sec1 />
      <SliderAbout2Sec2 />
    </>
  )
}

export default SliderAbout2
